/* eslint-disable no-console */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';
import useDefaultFields from '../../../../../hooks/useDefaultFields';
import DefaultFieldsForm from './DefaultFieldsForm';

const propTypes = {
  basePath: PropTypes.string,
};

function DefaultFieldsManager(props) {
  const history = useHistory();
  const params = useParams();
  const { defaultFields, isLoading } = useDefaultFields(params.defaultFieldId);

  const { locale } = useIntl();
  const context = useContext(CalloutContext);
  const okapiKy = useOkapiKy();

  const localizedName = defaultFields?.label?.find(
    (field) => field?.locale === locale,
  )?.value;

  const onEdit = (json) => {
    okapiKy
      .put(`inventory-defaultFields/${params.defaultFieldId}`, {
        timeout: 30000,
        method: 'PUT',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
        json,
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.DefaultFieldsForm.callout.updated"
            defaultMessage="Default field updated successfully"
          />
        );
        history.push(`${props.basePath}/Default-fields-list`);
        context.sendCallout({ message });
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text });
      });
  };

  const onSubmit = (values) => {
    onEdit({
      name: values.name,
      type: values.type,
      schema: values.schema,
      label: values.label,
      helpeText: values.helpeText,
      singularLabel: values.isRepeatable ? values.singularLabel : [],
      isRepeatable: values.isRepeatable,
      canEdit: values.canEdit,
      isRequired: values.isRequired,
      fieldDataOption: defaultFields.fieldDataOption,
      defaultValue: defaultFields.defaultValue,
      fieldArray: defaultFields.fieldArray,
      meta: values.meta,
      canDrive: defaultFields.canDrive,
      entityType: values.entityType,
      dataOptionsSource: defaultFields.dataOptionsSource,
      dataOptionsLimits: defaultFields.dataOptionsLimits,
    });
  };

  return (
    <DefaultFieldsForm
      localizedName={localizedName}
      onClose={() => history.go(-1)}
      onHandleSubmit={onSubmit}
      initialValues={defaultFields}
      isLoading={isLoading}
    />
  );
}

DefaultFieldsManager.propTypes = propTypes;

export default DefaultFieldsManager;
